<template>
  <div class="leave-msg" ref='vantaRef'>
    <div class="content">
    <div class="left">
      <Myself/>
      <!-- <SideContent title="友情链接" style="margin: 30px 0;border-radius: 12px;"/> -->
      <SideContent title="关注我" style="border-radius: 12px;"/>
    </div>
    <div class="right">
      <div v-for="item in 6">
        <MsgItem/>
      </div>
      <el-pagination
        background
        class="pagination"
        style="margin: 20px 0;"
        layout="prev, pager, next"
        :total="1000">
      </el-pagination>
      <el-card style="margin-top: 30px; margin-bottom: 30px;">
        <Comment/>
      </el-card>
    </div>
    </div>
  </div>
</template>

<script>
  import Myself from '../../components/Myself.vue'
  import SideContent from '../../components/SideContent.vue'
  import MsgItem from './components/MsgItem.vue'
  import Comment from './components/comment.vue'
  import {animateBg} from '../../utils/mixins.js'
  export default{
    name:'LeaveMsg',
    mixins:[animateBg],
    data(){
      return {
        vantaEffect:null
      }
    },
    components:{
      Myself,
      SideContent,
      MsgItem,
      Comment
    },
    methods:{

    }
  }
</script>

<style lang="scss">
  .leave-msg{
   background-color: #F5F7FA;
   margin-top: 20px;
   height: calc(100vh - 120px);
    .content{
      display: flex;
      justify-content: space-between;
      background-color: rgba(999, 999, 999, .6);
      width: 60%;
      margin: 0 auto;
      .left{
        width: 28%;
        margin-left: 20px;
      }
      .right{
        width: 68%;
        margin-right: 20px;
        position: relative;
        height:calc(100vh - 122px);
        overflow-y: scroll;
        overflow-x: hidden;
        .pagination{
          position: relative;
          bottom: 10px;
          left: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/leave-msg/leave-msg.vue